import React from "react";
import { clsx } from "clsx";
import { Link } from "gatsby";
import { icons } from "../data/category";

interface ICategoryProps extends React.PropsWithChildren {
  categoryId: string;
  name: string;

  /**
   * @default false
   */
  primary?: boolean;

  /**
   * @default false
   */
  primaryContent?: boolean;
}

export default function Category(props: ICategoryProps) {
  const { categoryId, name, primary, primaryContent } = props;
  const Icon = icons.find((icon) => icon.id === categoryId);

  return (
    <Link
      className={clsx("flex", "flex-col", "items-center", "space-y-2")}
      to={`/categories/${categoryId}`}
    >
      <div
        className={clsx(
          {
            "bg-primary/[.20]": primary,
            "bg-primary-content/[.20]": primaryContent,
          },
          "rounded-full",
          "p-4",
        )}
      >
        {Icon && <Icon.component className={clsx("w-8", "h-8")} />}
      </div>
      <div className={clsx("font-bold", "text-sm")}>{name}</div>
    </Link>
  );
}
